import styled from 'styled-components';

export const InsertDamageDetailsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  .label {
    font-size: 1rem !important;
    font-weight: 600 !important;
    color: #394760 !important;
    font-family: 'Inter' !important;
  }
`;

export const DamageDetailsHeaderContainer = styled.div`
  display: grid;
  /* Comportamento padrão (Desktop) */
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: dense;

    /* Propriedade fica na primeira posição (coluna 1) */
    > div:nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }

    /* Checkout fica na segunda posição (coluna 2) */
    > div:nth-child(3) {
      grid-column: 2;
      grid-row: 1;
    }

    /* Hóspede fica na segunda linha e ocupa 2 colunas */
    > div:nth-child(2) {
      grid-column: 1 / -1;
      grid-row: 2;
    }

    /* OTA Logo fica embaixo do card de hóspede e ocupa 2 colunas */
    > div:nth-child(4) {
      grid-column: 1 / -1;
      grid-row: 3;
    }
  }
`;

export const DamageDetailsHeaderItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  font-family: 'Inter';
  color: #394760;

  h3 {
    font-size: 1rem;
    font-weight: 400;
    color: #6a7282;
    margin-bottom: 2px;
  }

  p {
    font-size: 1rem;
    font-weight: 400;
  }
`;

export const AlertText = styled.p`
  color: #e06862;
`;

export const DamageTypeForm = styled.form`
  display: flex;
  flex-direction: column;
  font-family: 'Inter' !important;
  gap: 1rem;
  overflow: hidden;
  margin-top: 1rem;

  h3 {
    color: #394760;
    font-size: 1rem;
    font-weight: 600;
  }
`;

export const DamageTypeFieldForm = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  align-items: center;
  gap: 1rem;
`;

export const TypeButton = styled.button<{ isActive: boolean }>`
  display: flex;
  gap: 1rem;
  background-color: #d9d9d9;
  border: ${({ isActive }) => (isActive ? '1px solid #042675' : '1px solid #D9D9D9')};
  padding: 1.5rem;
  color: ${({ isActive }) => (isActive ? '#042675' : '#394760')};
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  align-items: center;

  svg {
    path: {
      fill: ${({ isActive }) => (isActive ? '#042675' : '#394760')};
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
  max-width: 440px;
  width: 100%;
  margin: 0 auto;

  button {
    background: #2a8645 !important;
    border: none !important;
  }
`;

export const RemoveItemButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  border: none;
  color: #e06862;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Inter';
  font-size: 0.875rem;

  &:hover {
    text-decoration: underline;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  width: 100%;
`;

export const FullDiv = styled.div`
  grid-column: 1 / -1;
  width: 100%;
`;

export const OtaLogo = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: end;

  img {
    max-width: 60px;
    max-height: 25px;
    object-fit: contain;
  }

  @media (max-width: 900px) {
    justify-content: flex-start;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 76px;
  }
`;

export const BlueTextFieldWrapper = styled.div<{ hasFile: boolean }>`
  flex: 1;

  ${({ hasFile }) =>
    hasFile &&
    `
    .MuiInputBase-input.Mui-disabled {
      color: #0055FF !important;
      -webkit-text-fill-color: #0055FF !important;
    }
  `}
`;
